import settings from './settings';
import { nanoid } from 'nanoid';
export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        for (let i = 0; i < 100; i++) {
          list.push({
            id: i,
            name: `Name #${nanoid()}`,
            column: nanoid(),
            column2: nanoid(),
            column4: nanoid(),
            column5: nanoid(),
            column6: nanoid()
          });
        }
        commit('set', list);
        commit('settings/set', Object.keys(list[0]));
      }
    }
  }
};
